/**
 * A CHAT CARD INTO THE STOREFRONT'S OWN CART (owner 10-23: "add to cart action"). The same `stylon:add-to-cart` event
 * every shop card fires (Pages/Home/HomeProductsStrip, Pages/Shop): CartContext listens and owns the basket — the chat
 * never keeps one of its own.
 *
 * `snapshot.price` is the SHELF price (CartContext: the checkout takes the campaign off itself). A card the chat shows
 * carries the price the customer pays; when that is a sale price the shelf price is not on the card, so the line is
 * stored at 0 and the cart reads the live list price itself (its self-heal) — never a sale price stored as the shelf
 * price. `shownPrice` is what the card showed, for the pixel.
 */
export function addToStorefrontCart(salonSlug, product, option) {
  const variantId = option?.variantId || product?.variantId;
  if (!salonSlug || !product?.id || !variantId) return null;
  const shown = option ? option.price : product.price;
  const onSale = Boolean(product.discountPct || product.compareAt);
  const name = option ? `${product.name} — ${option.label}` : product.name;
  window.dispatchEvent(new CustomEvent('stylon:add-to-cart', {
    detail: {
      salonSlug,
      productId: product.id,
      variantId,
      quantity: 1,
      shownPrice: typeof shown === 'number' ? shown : undefined,
      snapshot: { name, image: product.image || null, price: onSale || typeof shown !== 'number' ? 0 : shown },
    },
  }));
  window.dispatchEvent(new CustomEvent('stylon:cart-pulse'));
  return name;
}

/** A card can go into a cart: one variant, or options to pick from. */
export const canAddToCart = (p) => Boolean(p?.variantId || (p?.options || []).length);
